module.exports = __webpack_public_path__ + "static/media/heart-ratting-like-svgrepo-com.2b93c72a.svg";